module.exports = __webpack_public_path__ + "img/buy-now-fruit.0d51c25.png";